import "react";
import { Button, ButtonGroup, Icon } from "@therms/atalaya";
import { IoClose } from "react-icons/io5";
import { jsx, jsxs } from "react/jsx-runtime";
import { FaCheck } from "react-icons/fa6";
//#region src/modules/shared/LabeledInput/LabeledInputControlsButton.tsx
function LabeledInputControlsButton({ onCancel, onComplete }) {
	return /* @__PURE__ */ jsxs(ButtonGroup, {
		subtle: true,
		fullWidth: true,
		children: [onCancel && /* @__PURE__ */ jsx(Button, {
			onClick: onCancel,
			children: /* @__PURE__ */ jsx(Icon, {
				color: "critical",
				Icon: IoClose,
				size: "sm"
			})
		}), onComplete && /* @__PURE__ */ jsx(Button, {
			onClick: onComplete,
			variant: "main",
			children: /* @__PURE__ */ jsx(Icon, {
				Icon: FaCheck,
				color: "main",
				size: "sm"
			})
		})]
	});
}
//#endregion
export { LabeledInputControlsButton };

//# sourceMappingURL=LabeledInputControlsButton.js.map